import React, { useState, useEffect } from 'react';
import { settingsAPI } from '../../services/api';
import '../../styles/AdminStyles.css';

function AdminSettings() {
  const [settings, setSettings] = useState({
    admin_notification_email: '',
    cancellation_lockout_hours: '12',
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const data = await settingsAPI.getSettings();
      setSettings(data);
    } catch (error) {
      console.error('Error fetching settings:', error);
      alert('שגיאה בטעינת הגדרות');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(settings.admin_notification_email)) {
      alert('נא להזין כתובת אימייל תקינה');
      return;
    }

    // Validate lockout hours
    const lockoutHours = parseInt(settings.cancellation_lockout_hours);
    if (isNaN(lockoutHours) || lockoutHours < 0 || lockoutHours > 168) {
      alert('מספר שעות הנעילה חייב להיות בין 0 ל-168 (שבוע)');
      return;
    }

    setSaving(true);
    setMessage('');

    try {
      await settingsAPI.updateSettings(settings);
      setMessage('ההגדרות נשמרו בהצלחה');
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      console.error('Error saving settings:', error);
      alert('שגיאה בשמירת הגדרות');
    } finally {
      setSaving(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSettings((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  if (loading) {
    return (
      <div className="admin-loading">
        <div className="admin-spinner"></div>
        <p>טוען הגדרות...</p>
      </div>
    );
  }

  return (
    <div className="admin-settings">
      <div className="admin-header">
        <h1>הגדרות מערכת</h1>
        <p>ניהול הגדרות התראות ומערכת</p>
      </div>

      <form onSubmit={handleSubmit} className="admin-settings-form">
        <div className="admin-card">
          <h2>התראות אימייל</h2>
          <p className="admin-card-description">
            כתובת האימייל שתקבל התראות על תורים חדשים וביטולים
          </p>

          <div className="admin-form-group">
            <label>כתובת אימייל למנהל</label>
            <input
              type="email"
              name="admin_notification_email"
              value={settings.admin_notification_email}
              onChange={handleInputChange}
              placeholder="example@pilatehouse.com"
              required
              disabled={saving}
            />
            <small>למשל: admin@pilatehouse.com</small>
          </div>

          <div className="admin-notification-info">
            <h3>מתי יישלחו התראות?</h3>
            <ul>
              <li>✉️ כאשר משתמש קובע תור חדש</li>
              <li>✉️ כאשר משתמש מבטל תור</li>
            </ul>
          </div>
        </div>

        <div className="admin-card">
          <h2>הגדרות ביטול תורים</h2>
          <p className="admin-card-description">
            קבע כמה שעות לפני תחילת האימון ניתן לבטל תור
          </p>

          <div className="admin-form-group">
            <label>מספר שעות לנעילת ביטול</label>
            <input
              type="number"
              name="cancellation_lockout_hours"
              value={settings.cancellation_lockout_hours}
              onChange={handleInputChange}
              min="0"
              max="168"
              step="1"
              required
              disabled={saving}
            />
            <small>
              ברירת מחדל: 12 שעות. משתמשים לא יוכלו לבטל תור פחות מ-{settings.cancellation_lockout_hours} שעות לפני תחילת האימון.
              <br />
              0 = ניתן לבטל בכל עת | 24 = יום | 168 = שבוע
            </small>
          </div>

          <div className="admin-notification-info">
            <h3>דוגמאות:</h3>
            <ul>
              <li>🕐 12 שעות (ברירת מחדל) - ביטול עד חצות לפני אימון צהריים</li>
              <li>🕐 24 שעות - ביטול עד יום קודם באותה שעה</li>
              <li>🕐 0 שעות - ביטול חופשי בכל עת</li>
            </ul>
          </div>
        </div>

        <div className="admin-form-actions">
          <button
            type="submit"
            className="admin-button-primary"
            disabled={saving}
          >
            {saving ? 'שומר...' : 'שמור הגדרות'}
          </button>
        </div>

        {message && (
          <div className="admin-success-message">
            ✓ {message}
          </div>
        )}
      </form>
    </div>
  );
}

export default AdminSettings;
